module.exports = "/_next/static/images/8fc61c880ec6c0dc43d4e2986ba76339-box-coin-icon.svg.webp";